export default class DocumentTypes {
  static APPLICATION = 'application'
  static PERSONAL = 'personal'
  static SCAN_COPY = 'scan-copy'
  static SIGNED = 'signed'
  static TRANSPORT = 'transport'
}
